import { reactive } from 'vue';

const STORAGE_KEY = 'flow_state';

export const flowStore = reactive({
  flowId: null as string | null,
  step: null as string | null,
  data: {} as Record<string, any>,
  initialized: false, // 🔥 ajoute ce flag
});

function saveFlow() {
  if (!flowStore.flowId) return;

  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({
      flowId: flowStore.flowId,
      step: flowStore.step,
      data: flowStore.data,
    }),
  );
}

export function startFlow(flowId: string, step?: string) {
  flowStore.flowId = flowId;
  flowStore.step = step || null;
  flowStore.data = {};
  flowStore.initialized = false; // 🔥 reset auto au démarrage d'un nouveau parcours
  saveFlow();
}

export function updateFlowData(values: Record<string, any>) {
  Object.assign(flowStore.data, values);

  saveFlow();
}

export function setFlowStep(step: string) {
  flowStore.step = step;

  saveFlow();
}

export function resetFlow() {
  flowStore.flowId = null;
  flowStore.step = null;
  flowStore.data = {};
  flowStore.initialized = false; // 🔥

  localStorage.removeItem(STORAGE_KEY);
}

export function restoreFlow() {
  const saved = localStorage.getItem(STORAGE_KEY);

  if (!saved) return null;

  const parsed = JSON.parse(saved);

  flowStore.flowId = parsed.flowId;
  flowStore.step = parsed.step;
  flowStore.data = parsed.data || {};

  return parsed;
}
